import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/purchaseDelivery',
    meta: { title: '采购单提货' },
    component: Layout,
    redirect: '/purchaseDelivery/list',
    children: [
      {
        path: 'list',
        meta: { title: '采购单提货', activeMenu: '/purchaseDelivery' },
        component: () => import('@/views/purchaseDelivery/PurchaseDelivery.vue')
      },
      {
        path: 'detail',
        meta: { title: '提货详情', activeMenu: '/purchaseDelivery' },
        component: () => import('@/views/purchaseDelivery/PurchaseDeliveryDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增提货', activeMenu: '/purchaseDelivery' },
        component: () => import('@/views/purchaseDelivery/PurchaseDeliveryAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑提货', activeMenu: '/purchaseDelivery' },
        component: () => import('@/views/purchaseDelivery/PurchaseDeliveryAdd.vue')
      }

    ]
  }

]
